import React, { useContext, useEffect, useState, useRef } from 'react';

import {FeatureGatingContext} from '../../contexts';
import { useCallToAction } from '../useMerchantSettings';

import './call-to-action.scss';

export function CallToAction() {
  const { checkFeatureQuota } = useContext(FeatureGatingContext);
  const { ctaLink } = useCallToAction();
  const [allowed, setAllowed] = useState(false);
  const showModalFnRef = useRef(null);

  const checkQuota = async () => {
    const { allowed, showModal } = await checkFeatureQuota(FeatureGatingContext.features.CLIENT_PRODUCT_REQUEST, 1, false);

    setAllowed(allowed);

    if (!allowed) {
      showModalFnRef.current = showModal;
    }
  }

  useEffect(() => {
    checkQuota();
  }, []);

  const onClickCta = () => {
    if (showModalFnRef.current) {
      showModalFnRef.current();
    } else {
      window.open(ctaLink, '_blank');
    }
  }

  return (
    <div className="call-to-action">
      <div className="row customize">
        <div className="col-6 label">Button Position</div>
        <div className="col-6">
          <button type="button" onClick={onClickCta} disabled={allowed && !ctaLink} className="btn btn-primary">
            Customize
          </button>
        </div>
      </div>
    </div>
  );
}
